module.exports = __webpack_public_path__ + "static/img/radio_bg.22c5085c.png";